import React, { useState, useEffect } from 'react';
import api from '../api/axios';
import './Staking.css';

export default function Staking() {
  const [staked, setStaked] = useState<number>(0);
  const [rewards, setRewards] = useState<number>(0);
  const [amount, setAmount] = useState<number>(0);
  const [loading, setLoading] = useState(false);

  const DAILY_RATE = 0.10; // 10%

  const fetchInfo = async () => {
    try {
      const { data } = await api.get<{
        staked: number;
        rewards: number;
      }>('/staking');
      setStaked(data.staked);
      setRewards(data.rewards);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    fetchInfo();
    const iv = setInterval(fetchInfo, 60_000);
    return () => clearInterval(iv);
  }, []);

  const handleStake = async () => {
    if (amount <= 0) return;
    setLoading(true);
    try {
      const { data } = await api.post<{ message: string }>('/staking/stake', { amount });
      alert(data.message);
      setAmount(0);
      fetchInfo();
    } catch (e: any) {
      alert(e.response?.data?.error || e.message);
    } finally {
      setLoading(false);
    }
  };

  const handleWithdraw = async () => {
    setLoading(true);
    try {
      const { data } = await api.post<{
        message: string;
        totalReturn: number;
        gold: number;
      }>('/staking/withdraw');
      alert(data.message);
      fetchInfo();
    } catch (e: any) {
      alert(e.response?.data?.error || e.message);
    } finally {
      setLoading(false);
    }
  };

  // calculate daily accrual
  const dailyAccrual = Number((staked * DAILY_RATE).toFixed(2));

  return (
    <div className="staking-page">
      <div className="staking-container">
        <h3>Staking</h3>
        <p>Currently Staked: <strong>{staked.toFixed(2)}</strong> gold</p>
        <p>Daily Rewards (10%): <strong>{dailyAccrual}</strong> gold/day</p>
        <p>Actual Rewards: <strong>{rewards.toFixed(2)}</strong> gold</p>
        <p><strong>Note:</strong> Rewards are distributed every second.</p>

        <div className="controls">
          <input
            type="number"
            value={amount}
            onChange={(e) => setAmount(+e.target.value)}
            placeholder="Gold to stake"
          />
          <button
            className="staking-btn"
            onClick={handleStake}
            disabled={loading || amount <= 0}
          >
            {loading ? '…' : 'Stake Gold'}
          </button>
        </div>

        <div className="controls">
          <button
            className="staking-btn"
            onClick={handleWithdraw}
            disabled={loading || staked <= 0}
          >
            {loading ? '…' : 'Withdraw Staked Gold'}
          </button>
        </div>
      </div>
    </div>
  );
}
